import { observer } from 'mobx-react-lite'
import React from 'react'
import { TAGS_NAME_LIMIT } from 'shared/constants/limits'
import { Error, TextFieldWithLabel } from 'shared/ui'
import { makeTextFieldAutoFocus } from 'shared/ui/TextField'
import { type TagsModalStore } from 'pages/settings/pages/tags/store/TagsModalStore'
import styles from './styles.module.scss'

export type ITagsModalContentProps = {
  tagsModalStore: TagsModalStore
}

export const TagsModalContent = observer(({ tagsModalStore }: ITagsModalContentProps) => {
  const { setName, name, removeError, errorsMap } = tagsModalStore
  const error = errorsMap.get('name')

  return (
    <div style={{ marginTop: '-8px' }}>
      <TextFieldWithLabel
        labelProps={{
          label: {
            text: 'Tag name',
          },
        }}
        textFieldProps={{
          value: name,
          onChange: setName,
          onFocus: () => removeError('name'),
          InputProps: {
            placeholder: 'Enter tag name',
          },
          className: styles.name,
          mainActions: [
            makeTextFieldAutoFocus({
              withFocus: true,
            }),
          ],
        }}
        errorBorder={!!error}
        limit={TAGS_NAME_LIMIT}
      />
      {error && <Error type={'text'} error={error} />}
    </div>
  )
})
